import { useState, useEffect } from "react";
import axios from "axios";

export const useAppsHome = () => {
  const [apps, setApps] = useState([]);
  const [loadingApps, setLoadingApps] = useState(false);

  useEffect(() => {
    const getApp = async () => {
      try {
        setLoadingApps(true);
        const { data } = await axios.get(
          `${process.env.REACT_APP_Auth_API_BASE_URL}/app`
        );
        setApps(data?.map(A => ({
          _id: A?._id,
          name: A?.name,
          titleAr: A?.titleAr,
          titleEn: A?.titleEn,
          descAr: A?.descAr,
          descEn: A?.descEn,
          img: A?.img,
          icon: A?.icon,
          baseUrl: A?.baseUrl,
          apiBaseUrl: A?.apiBaseUrl || A?.apiUrl || A?.api_base_url,
          status: A?.status,
        })));
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingApps(false);
      }
    };

    getApp();
  }, []);

  return { apps, loadingApps };
};
